import styled from 'styled-components';
import FormRow from './form-row';
import TextField from './text-field';
import TextArea from './text-area';

// Re-export the form components
export { FormRow, TextField, TextArea };

// Also export a styled form component
export const Form = styled.form`
  max-width: 32rem;
  margin-bottom: 3rem;
  
  /* Apply theme styles only when not using blank skin */
  ${({ theme }) => theme.name !== 'blank' && `
    max-width: ${theme.form?.form?.maxWidth || '32rem'};
    margin-bottom: ${theme.form?.form?.marginBottom || '3rem'};
  `}
`;

// Default export for convenience
const FormComponents = {
  Form,
  FormRow,
  TextField,
  TextArea
};

export default FormComponents;

